import { render, staticRenderFns } from "./MakeDistribution.vue?vue&type=template&id=1ba7f9cc&"
import script from "./MakeDistribution.vue?vue&type=script&lang=js&"
export * from "./MakeDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports